import Image from 'components/Common/Image'
import { rem } from 'polished'
import styled from 'styled-components'

const StyledImage = styled(Image)`
  height: ${rem(28)};
  width: auto;
`

interface Props {
  image: App.Image
  className?: string
}

function SponsoredTileLogo({ image, className }: Props) {
  return <StyledImage image={image} width={226} dpr={2} className={className} />
}

export default SponsoredTileLogo
